/**
 * Runs `fn` on the next macrotask (after the current React commit).
 * Use before Sonner when the action may unmount the element that triggered it
 * (e.g. refetch removes a card) — avoids DOM insertBefore NotFoundError races.
 */
export function toastNextTask(fn: () => void): void {
  window.setTimeout(fn, 0);
}
